import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { whatsTip } from '../configuration-panel/helpers/constants';
import { WINDOW } from 'src/app/utils/window';

@Component({
  selector: 'app-whats',
  templateUrl: `./whats.component.html`,
  styleUrls: ['./whats.component.scss']
})
export class WhatsComponent implements OnInit, OnDestroy{
  whats = whatsTip;
  showButton: boolean = false;
  screenWidth = this.window.innerWidth;

  subscriptionResize!: Subscription;
  subscriptionHideNavMenu!: Subscription;

  constructor(
    private dataService: DataService,
    @Inject(WINDOW) private window: Window) { }

  ngOnInit(): void {
    this.subscriptionHideNavMenu = this.dataService.getHideNavMenu().subscribe(res => this.showButton = res);
    this.subscriptionResize = this.dataService.getScreenSize().subscribe(res => this.screenWidth = res);
  }

  ngOnDestroy(): void {
    this.subscriptionHideNavMenu?.unsubscribe();
    this.subscriptionResize?.unsubscribe();
  }

  getIsValidTime() {
    const currentString = new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" });
    const now = new Date(currentString);
    return this.isValidTime(now);
  }

  isValidTime(now: Date) {
    const currentTime = now.getHours() * 60 + now.getMinutes();

    const daysOfWeekend = [0, 6];

    let start = daysOfWeekend.includes(now.getDay()) ? 10 * 60 + 30 : 8 * 60 + 30;
    let end = 19 * 60 + 59;

    return start <= currentTime && currentTime <= end;
  }

  showInBuscador(){
    if(location.pathname.includes('buscador')){
      if(this.screenWidth > 767)
        return true;

      return this.showButton;
    } else{
      this.showButton = false;
      return true;
    }
  }


}


